import { render, staticRenderFns } from "./ModuleSelection.vue?vue&type=template&id=78272e4c&"
import script from "./ModuleSelection.vue?vue&type=script&lang=js&"
export * from "./ModuleSelection.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSelection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
